import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0373 6.80169C19.822 7.99742 21.2034 9.70491 22 11.7C22.0162 11.7993 22.0162 11.9006 22 12C22.0033 12.1129 21.9828 12.2253 21.94 12.33C21.1424 14.3098 19.7682 16.0043 17.9958 17.1936C16.2234 18.383 14.1345 19.0123 12 19C9.86325 19.0107 7.77267 18.3784 5.99999 17.1854C4.22731 15.9923 2.85451 14.2935 2.06001 12.31C2.01987 12.2116 1.99948 12.1062 2.00001 12C2.00129 11.8874 2.02157 11.7758 2.06001 11.67C2.85765 9.6901 4.2318 7.99562 6.00423 6.80627C7.77665 5.61693 9.86556 4.98761 12 4.99995C14.1481 4.97789 16.2527 5.60596 18.0373 6.80169ZM10.3333 14.4944C10.8266 14.824 11.4067 15 12 15C12.7957 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.4066 14.8241 10.8266 14.4944 10.3332C14.1648 9.83989 13.6962 9.45538 13.1481 9.22831C12.5999 9.00125 11.9967 8.94184 11.4147 9.0576C10.8328 9.17335 10.2982 9.45907 9.87869 9.87863C9.45913 10.2982 9.17341 10.8327 9.05765 11.4147C8.9419 11.9966 9.00131 12.5998 9.22837 13.148C9.45543 13.6962 9.83995 14.1647 10.3333 14.4944Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgShow = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgShow;
